<template>
    <HelpButton @click="isShowDialog = true" />

    <!-- ヒント用のダイアログ -->
    <HelpDialog :isShow="isShowDialog" @close="isShowDialog = false" title="テスト環境設定画面について">
        <template v-slot:contents>
            <div>
                <h2>■テスト環境選択方法</h2>
                <p>
                    1. T-DASHをGUI起動する<br>
                    2. テストラン一覧画面を開く<br>
                    3. テストラン作成ボタン or 作成済みテストラン名 をクリック<br>
                    4. 開かれたモーダル上部
                </p>
                <img src="@/assets/helps/HowToSet-TestEnv.png" alt="Syncフォルダのパス取得方法1" width="900px">
            </div>
        </template>
    </HelpDialog>
</template>
<script>
import { ref } from 'vue'

export default {
    name: 'TestEnvHelp',
    setup() {

        // ###########
        // ダイアログ #
        // ###########
        const isShowDialog = ref(false)
        const updateDialog = (state) => {
            isShowDialog.value = state
        }

        return { updateDialog, isShowDialog }
    }
}
</script>
